/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { OAuthAuthenticationQueryV1 } from '../models/o-auth-authentication-query-v-1';
import { WebhookAuthConfigCreateCommandV1 } from '../models/webhook-auth-config-create-command-v-1';
import { WebhookAuthConfigUpdateCommandV1 } from '../models/webhook-auth-config-update-command-v-1';


/**
 * API for managing webhook endpoint/auth configuration. Ops-only - no UI, per the AC.
 */
@Injectable({
  providedIn: 'root',
})
export class WebhookAuthConfigV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getWebhookAuthConfigV1
   */
  static readonly GetWebhookAuthConfigV1Path = '/v1/webhook-auth-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWebhookAuthConfigV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWebhookAuthConfigV1$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<OAuthAuthenticationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookAuthConfigV1Service.GetWebhookAuthConfigV1Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OAuthAuthenticationQueryV1>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWebhookAuthConfigV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWebhookAuthConfigV1(params: {
    id: string;
  },
  context?: HttpContext

): Observable<OAuthAuthenticationQueryV1> {

    return this.getWebhookAuthConfigV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<OAuthAuthenticationQueryV1>) => r.body as OAuthAuthenticationQueryV1)
    );
  }

  /**
   * Path part for operation updateWebhookAuthConfigV1
   */
  static readonly UpdateWebhookAuthConfigV1Path = '/v1/webhook-auth-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateWebhookAuthConfigV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWebhookAuthConfigV1$Response(params: {
    id: string;
    body: WebhookAuthConfigUpdateCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<OAuthAuthenticationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookAuthConfigV1Service.UpdateWebhookAuthConfigV1Path, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OAuthAuthenticationQueryV1>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateWebhookAuthConfigV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateWebhookAuthConfigV1(params: {
    id: string;
    body: WebhookAuthConfigUpdateCommandV1
  },
  context?: HttpContext

): Observable<OAuthAuthenticationQueryV1> {

    return this.updateWebhookAuthConfigV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<OAuthAuthenticationQueryV1>) => r.body as OAuthAuthenticationQueryV1)
    );
  }

  /**
   * Path part for operation deleteWebhookAuthConfigV1
   */
  static readonly DeleteWebhookAuthConfigV1Path = '/v1/webhook-auth-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWebhookAuthConfigV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWebhookAuthConfigV1$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookAuthConfigV1Service.DeleteWebhookAuthConfigV1Path, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWebhookAuthConfigV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWebhookAuthConfigV1(params: {
    id: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteWebhookAuthConfigV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation listWebhookAuthConfigsV1
   */
  static readonly ListWebhookAuthConfigsV1Path = '/v1/webhook-auth-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWebhookAuthConfigsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWebhookAuthConfigsV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<OAuthAuthenticationQueryV1>>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookAuthConfigV1Service.ListWebhookAuthConfigsV1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OAuthAuthenticationQueryV1>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWebhookAuthConfigsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWebhookAuthConfigsV1(params?: {
  },
  context?: HttpContext

): Observable<Array<OAuthAuthenticationQueryV1>> {

    return this.listWebhookAuthConfigsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<OAuthAuthenticationQueryV1>>) => r.body as Array<OAuthAuthenticationQueryV1>)
    );
  }

  /**
   * Path part for operation createWebhookAuthConfigV1
   */
  static readonly CreateWebhookAuthConfigV1Path = '/v1/webhook-auth-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWebhookAuthConfigV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWebhookAuthConfigV1$Response(params: {
    body: WebhookAuthConfigCreateCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<OAuthAuthenticationQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookAuthConfigV1Service.CreateWebhookAuthConfigV1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OAuthAuthenticationQueryV1>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWebhookAuthConfigV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWebhookAuthConfigV1(params: {
    body: WebhookAuthConfigCreateCommandV1
  },
  context?: HttpContext

): Observable<OAuthAuthenticationQueryV1> {

    return this.createWebhookAuthConfigV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<OAuthAuthenticationQueryV1>) => r.body as OAuthAuthenticationQueryV1)
    );
  }

}
